import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getConditionsFilterConfig } from '../filters/condition';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { Currency } from '../../types/apollo/generated/types.generated';
import { BuilderSections } from '../../util/builder';

const ohpollySizes: string[] = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
];

const allSizeVariantOptionNames = ['size', 'uk size'];

export const ohpollyShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    // getBrandDirectFilterConfig(), Temporarily disabled, will re-enable once they start Brand Direct.
    getConditionsFilterConfig(),
    getSizeFilterConfig({
      sizes: ohpollySizes,
    }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: 'ed82c5de80a742978c717b997f8e859c',
    },
  },
  // Temporarily disabled, will re-enable once they start Brand Direct in 2-3 weeks
  // returnShippingPrice: {
  //   price: 300,
  //   currency: Currency.Gbp,
  // },
  allSizeVariantOptionNames,
};
